import { getPreviouslySelectedOptionForQuestionWidget } from '../../../../../../store/reducers/student/tracking/questionWidgetTrackingSelectors';
import { ContentItemType, SingleResponseQuestionWidget } from '@ael/core-api';
import { createSelector } from 'reselect';

export type PreviouslySelectedOptionIndex = number | null;

type QuestionWidgetWithSavedAnswer = {
  previouslySelectedOptionIndex: PreviouslySelectedOptionIndex;
  saveSelectedOption: (answerIndex: number) => void;
  resetSelectedOption: () => void;
};

const calculatePreviouslySelectedOptionIndex = (
  previouslySelectedOptionIndex: PreviouslySelectedOptionIndex,
  maxIndex: number
) => {
  if (previouslySelectedOptionIndex === null) {
    return null;
  }

  if (previouslySelectedOptionIndex > maxIndex) {
    return null;
  }

  return previouslySelectedOptionIndex;
};

const createGetSavedOptionsForQuestionWidget =
  (setWidgetOption: SetSelectedOption, resetWidgetOption: ResetWidgetOption) =>
  (
    getSelectedAnswerForWidget: (
      item: ContentItemType,
      questionWidget: SingleResponseQuestionWidget
    ) => PreviouslySelectedOptionIndex
  ) =>
  (item: ContentItemType, questionWidget: SingleResponseQuestionWidget): QuestionWidgetWithSavedAnswer => {
    const previouslySelectedOptionIndex = getSelectedAnswerForWidget(item, questionWidget);
    const maxIndex = questionWidget.value.data.options.length - 1;
    return {
      previouslySelectedOptionIndex: calculatePreviouslySelectedOptionIndex(previouslySelectedOptionIndex, maxIndex),
      saveSelectedOption: (answerIndex: number) => {
        if (answerIndex > maxIndex) {
          throw Error('Unexpected try to save index bigger than options count.');
        }
        setWidgetOption(questionWidget, answerIndex);
      },
      resetSelectedOption: () => {
        resetWidgetOption(questionWidget);
      },
    };
  };

export type SetSelectedOption = (questionWidget: SingleResponseQuestionWidget, selectedOption: number) => void;
export type ResetWidgetOption = (questionWidget: SingleResponseQuestionWidget) => void;

export const getSavedOptionsForQuestionWidget = (
  setWidgetOption: SetSelectedOption,
  resetSelectedOption: ResetWidgetOption
) =>
  createSelector(
    getPreviouslySelectedOptionForQuestionWidget,
    createGetSavedOptionsForQuestionWidget(setWidgetOption, resetSelectedOption)
  );
